module.exports = __webpack_public_path__ + "img/tiefling_6.dfff5a05.png";